const refundHTML = `<strong>Refund Policy</strong> 
<p>
Thanks for shopping at SAARTHI: freshokartz, if you are not entirely satisfied with your purchase,
we're here to help.
</p>

<strong>
Returns & Exchange
</strong> 

<p>
Kindly send us a photograph of the order to info@freshokartz.com along with your name, your order number. Normal priced items are refundable within 7 days from your invoice data based on the following conditions
</p>

<p>
To be eligible for a return, merchandise must be in original condition or defective merchandise with all original packaging including any related accessories that you received it.
Exchange Policy is granted  for 1 time only for each item.
</p>
<strong>REFUNDS:</strong> 
<p>
Once we receive your item, we will inspect it and notify you that we have received your returned item. We will immediately notify you on the status of your refund after inspecting the item.
</p>
<p>
If your return is approved, we will initiate a refund to your by Direct Online Banking. You will receive the credit within a certain amount of days, depending on your card issuer's policies.
</p>
<p>
  <strong>SHIPPING:</strong>
</p>



  <p>
  You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping wil be deducted from your refund.
  </p>

<p>
  <strong>CONTACT US </strong>
</p>

  <p>
  If you have any query on how to return your item to us, please contact us at info@freshokartz.com.
  </p>`

  

export default refundHTML;